import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTransferArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 12,
	viewBox: "0 0 22 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.6673 10.9022C11.2875 11.2424 10.7125 11.2424 10.3327 10.9022L0.39021 1.99482C-0.293233 1.38253 0.13988 0.250002 1.05748 0.250002L20.9425 0.25C21.8601 0.25 22.2932 1.38253 21.6098 1.99482L11.6673 10.9022Z",
		fill: "#C70909"
	})
});
export default SvgTransferArrowDown;
